import DataImplementation from './DataImplementation.js';
export default function hydrateImplementationFromReferences(props, references) {
    const referencesById = references.reduce((memo, ref) => {
        memo[ref.id] = ref;
        return memo;
    }, {});
    const implementation = { ...props };
    implementation.ref = referencesById[implementation.ref.id];
    if (implementation.normalization && implementation.normalization.ref) {
        implementation.normalization.ref = referencesById[implementation.normalization.ref.id];
    }
    return new DataImplementation(implementation);
}
